import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import Button from '_components/atomic/Button';
import { theme } from '_constants/theme';
import { config } from '_config';
import Navbar from './Navbar';
import Burger from './Burger';
import PhoneItem from './PhoneItem';
import SearchItem from './SearchItem';

const { colors, devices } = theme;

const StyledNavMenu = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-top: 16px;
  padding-bottom: 16px;

  .nav-logo {
    img {
      height: 36px;
      margin-right: 18px;
    }
  }

  .nav-menu {
    display: flex;
    flex: auto;
    justify-content: space-between;
    align-items: center;

    a {
      display: block;

      padding-left: 12px;
      padding-right: 12px;

      font-family: 'Aeonik';
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
      color: ${colors.gray[500]};

      text-decoration: none;
      white-space: nowrap;

      &:hover {
        text-decoration: none;
      }
    }

    a.active {
      color: ${colors.blue[500]};
    }
  }

  .mobile-nav-menu {
    display: none;

    a {
      text-decoration: none;
      white-space: nowrap;

      &:hover {
        text-decoration: none;
      }
    }
  }
  @media ${devices.laptopM} {
    .nav-logo {
      img {
        padding-left: 12px;
      }
    }
  }
  @media ${devices.laptopS} {
    padding-right: 4%;
    padding-left: 4%;
  }

  @media ${devices.tablet} {
    padding-right: 10px;
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    .nav-menu {
      display: none;
    }

    .nav-logo {
      img {
        height: 30px;
      }
    }

    .mobile-nav-menu {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-grow: 1;
    }
  }
`;

function NavMenu({ open, handleOpen }) {
  return (
    <StyledNavMenu>
      <div className="nav-logo">
        <Link href="/">
          <picture>
            <img
              src={`${config.basePath}/images/logo.svg`}
              alt=""
              layout="fill"
            />
          </picture>
        </Link>
      </div>

      <div className="nav-menu">
        <Navbar />
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <PhoneItem />
          <SearchItem />
          <Link href={config.membership}>
            <Button color={colors.blue[500]}>Log in</Button>
          </Link>
        </div>
      </div>
      <div className="mobile-nav-menu">
        <Link href={config.membership}>
          <Button color={colors.blue[500]}>Log in</Button>
        </Link>
        <Burger open={open} handleOpen={handleOpen} />
      </div>
    </StyledNavMenu>
  );
}

export default NavMenu;
